export const getBreadcrumbs = title => [
  { title: "Agronomist", url: "/" },
  { title: "Kredytomat", url: "/kredytomat" },
  { title },
];
